import Splide from '@splidejs/splide';

export const productCarousels = function () {

    const productCarousels = document.querySelectorAll('.product-carousel');
    if (productCarousels.length > 0) {
        productCarousels.forEach(carousel => new Splide(carousel, {
            type: 'loop',
            perPage: 6,
            gap: 15,
            focus: 'center',
            breakpoints: {

                1000: {
                    perPage: 4
                },
                600: {
                    perPage: 2
                },
            },
        }).mount());
    }

};